import { Segment } from '@mairistem/composants';
import { PiecesJointesProvider, Sens } from '@mairistem/comptabilite';
import { App, Feature, Menu, SpeedDial } from '@mairistem/module';
import { Viewer } from '@mairistem/piecesjointes';
import { newIdentifiant, request } from '@mairistem/tools';
import React from 'react';
import Context from './components/Context';
import LiquidationContainer from './components/Liquidation/LiquidationTreeView/LiquidationContainer';
import MouvementFiche from './components/Mouvement/Fiche/MouvementFiche';
import TestPes from './components/TestPes/TestPes';
import TiersFiche from './components/Tiers/Fiche/TiersFiche';
import TiersListeContainer from './components/Tiers/TiersListe/TiersListeContainer';
import StorageKey from './constants/common/storageKey';

const AppComptabilite = () => {
	const handleOnAuth = async () => {
		const queryParams = new URLSearchParams(window.location.search);
		sessionStorage.setItem(
			StorageKey.IDENTIFIANT_ENTITE,
			queryParams.get('identifiantEntite'),
		);
		sessionStorage.setItem(
			StorageKey.IDENTIFIANT_EXERCICE,
			queryParams.get('identifiantExercice'),
		);
	};

	return (
		<App
			code="HOL_CPTA"
			context={Context}
			onAuth={handleOnAuth}
			group="finances"
			name="Exécution budgétaire"
			request={request}
		>
			<Feature path="/:path*/preview/" name="Prévisualisation">
				<Feature.Content>{Viewer}</Feature.Content>
			</Feature>

			<Menu name="Tiers" icon="users" path="/tiers" dataTestId="accueil-tiers">
				<Feature path="/:identifiant">
					<Feature.Content>
						<PiecesJointesProvider>
							<TiersFiche />
						</PiecesJointesProvider>
					</Feature.Content>
				</Feature>
				<Feature>
					<Feature.Content>
						<Segment inverted attached className="feature">
							<Segment>
								<TiersListeContainer />
							</Segment>
						</Segment>
					</Feature.Content>
				</Feature>
			</Menu>

			<Menu
				icon="suitcase"
				name="Ordonnancement"
				path="/liquidations"
				dataTestId="accueil-ordonnancement"
			>
				<Feature>
					<Feature.Content>{LiquidationContainer}</Feature.Content>
				</Feature>
				<Feature path="/:identifiant">
					<Feature.Content>
						<PiecesJointesProvider>
							<MouvementFiche />
						</PiecesJointesProvider>
					</Feature.Content>
				</Feature>
			</Menu>

			{/* TODO: page de test temporaire de l'API PES, à supprimer */}
			<Menu name="Test PES" icon="bug" path="/test-pes">
				<Feature>
					<Feature.Content>
						<TestPes />
					</Feature.Content>
				</Feature>
			</Menu>
			<SpeedDial>
				<SpeedDial.Button
					name="create_tiers"
					icon="users"
					title="Création d'un tiers"
					path={`/tiers/${newIdentifiant()}`}
					dataTestId="tiersAjouter"
				/>
				<SpeedDial.Button
					name="create_mandat"
					icon="file"
					title="Création d'un mandat"
					path={`/liquidations/${newIdentifiant()}?sens=${Sens.DEPENSE}`}
					dataTestId="mandatsAjouter"
				/>
				<SpeedDial.Button
					name="create_titre"
					icon="file"
					title="Création d'un titre"
					path={`/liquidations/${newIdentifiant()}?sens=${Sens.RECETTE}`}
					dataTestId="titreAjouter"
				/>
			</SpeedDial>
		</App>
	);
};

export default AppComptabilite;
